export { AuthPageLoginViewFooter } from "./AuthPageLoginViewFooter";
export { LoginViewFooter } from "./LoginViewFooter";
export { LoginWithMagicLinkSuccessFooter } from "./LoginWithMagicLinkSuccessFooter";
export { ResetPasswordFooter } from "./ResetPasswordFooter";
export { SendResetPasswordLinkFooter } from "./SendResetPasswordLinkFooter";
